import {
    Select,
    OutlinedInput,
    MenuItem,
    ListItemText,
    ListSubheader,
    Checkbox,
} from '@mui/material';
import React from 'react';

export default function TagsFilter({ onChange, value, tagGroups, tagList }) {
    console.log({tagGroups, tagList})
    return (
            <Select
                size="small"
                fullWidth
                labelId="mx-filter-tag-label"
                id="mx-filter-tag"
                multiple
                value={value}
                onChange={(e) => onChange(e.target.value)}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => selected.join(', ')}
            >
                {tagGroups.map((group) =>
                    [
                        <ListSubheader sx={{ backgroundColor: '#eee' }} key={`tag-group-${group}`}>
                            {group}
                        </ListSubheader>,
                    ].concat(
                        tagList[group]
                            ?.sort((t1, t2) => (t1.name < t2.name ? -1 : 1))
                            .map(({ id, name }) => (
                                <MenuItem key={name} value={group + '_' + id}>
                                    <Checkbox checked={value.indexOf(group + '_' + id) > -1} />
                                    <ListItemText primary={name} />
                                </MenuItem>
                            ))
                    )
                )}
            </Select>
    );
}
